import React, { useState, useEffect } from 'react';
import Service from '../../apiService';

function useDataRequesting() {
  const [ loading, setLoading ] = useState(false);
  const [ results, setResults ] = useState('');
  const [ error, setError ] = useState('');
  const [ request, setRequest ] = useState({});

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const response = await Service.fetch(request);
        if (response) {
          setLoading(false);
          setResults(response);
        }
      } catch (catchError) {
        setLoading(false);
        setResults([])
        setError(catchError);
        setError('');
      }
      setLoading(false);
    }
    if (Object.values(request).length) fetchData();
  }, [ request ]);

  return {
    error,
    loading,
    results,
    setRequest
  };
}

export default useDataRequesting;
